import { render, staticRenderFns } from "./RewardsCart.vue?vue&type=template&id=25054e34"
import script from "./RewardsCart.vue?vue&type=script&lang=js"
export * from "./RewardsCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports